<mat-form-field appearance="fill" class="modal-custom-class">
  <mat-label class="label-custom-class">Selectează motivul de respingere:</mat-label>
  <mat-select [formControl]="selectedDocuments" (selectionChange)="showSendButton = true">
    <ng-container *ngIf="requestType === 'riparian'">
      <mat-option class="option-custom-class" *ngFor="let document of riparianParkingDocumentsList" [value]="document">
        {{ document }}
      </mat-option>
    </ng-container>
    <ng-container *ngIf="requestType === 'home'">
      <mat-option class="option-custom-class" *ngFor="let document of homeParkingDocumentsList" [value]="document">
        {{ document }}
      </mat-option>
    </ng-container>
    <button class="btn-other" (click)="openDialog(requestId)">Alte motive</button>
  </mat-select>
  <div *ngIf="showSendButton">
    <button class="btn-send" (click)="sendOption()">Send</button>
  </div>
</mat-form-field>